import { render, staticRenderFns } from "./ErrorReview.vue?vue&type=template&id=82047562&scoped=true"
import script from "./ErrorReview.vue?vue&type=script&lang=js"
export * from "./ErrorReview.vue?vue&type=script&lang=js"
import style0 from "./ErrorReview.vue?vue&type=style&index=0&id=82047562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82047562",
  null
  
)

export default component.exports